<template src="../../templates/card/animal-card.pug" lang="pug"></template>


<script>
import { mapActions, mapGetters } from 'vuex'
import LineChart from '../../helpers/chart/inspection-result-big'
import differenceInDays from 'date-fns/difference_in_days'
import _forEachRight from 'lodash/forEachRight'
import _each from 'lodash/each'
import _filter from 'lodash/filter'
import _orderBy from 'lodash/orderBy'
import { format } from 'date-fns'
import { getFecondityStatus } from '../../libs/state'

export default {
    name: 'AnimalCard',
    props: ['animalToCard'],
    components: {
        LineChart
    },
    data() {
        return {
            animal: {},
            lastDriedDate: Math.trunc(Date.now() / 1000),
            lastCalvingDate: null,
            beforeLastCalvingDate: null,
            lactationNumber: 0,
            format
        }
    },
    computed: {
        ...mapGetters(['selectedFarm', 'isUserVisitor']),
        getLastTwoCalving() {
            let self = this
            return _orderBy(_filter(this.animal.states, function(s) {
                if (self.$route.name !== 'culled') {
                    return s.date >= self.beforeLastCalvingDate
                }
                return true
            }),['date'], ['desc'])
        },
        getMilkChartWidth() {
            return this.$route.name === 'pwa-animal-card' ? window.innerWidth - 8 : 996
        },
        getLactationDays() {
            if (this.lastCalvingDate != null) {
                let self = this
                _each(this.animal.states, function(s) {
                    if (s.state === 'dried' && s.date > self.lastCalvingDate) {
                        self.lastDriedDate = s.date
                    }
                })
                return differenceInDays(this.lastDriedDate * 1000, this.lastCalvingDate * 1000)
            }
            return 0
        },
        getLastLactationProductivity() {
            let self = this
            let milkInspectionCount = 0
            let milkInspectionAverageSum = 0
            _each(this.animal.milkResults, function(mi) {
                if (mi.date >= self.lastCalvingDate && mi.date <= self.lastDriedDate) {
                    milkInspectionCount++
                    milkInspectionAverageSum = milkInspectionAverageSum + mi.total
                }
            })
            if (milkInspectionCount === 0 && milkInspectionAverageSum === 0) {
                return 0
            }
            return Math.trunc(milkInspectionAverageSum / milkInspectionCount)
        },
        getInseminationSuccessRate() {
            let lactationCount = 0
            let inseminationRate = 0
            let inseminationCount = 0
            let orderedState = _orderBy(this.animal.states, ['date'], ['desc'])
            _each(orderedState, function(os) {
                if(os.state === 'insemination') {
                    inseminationCount++
                } else if (os.state === 'calving' && inseminationCount > 0) {
                    inseminationRate = inseminationRate + (1/inseminationCount)
                    lactationCount++
                    inseminationCount = 0
                }
            })
            return ((inseminationRate/lactationCount)*100).toFixed(2)
        }
    },
    created() {

        if(this.$route.name === 'pwa-animal-card') {
            this.animal = this.$route.params.animalToCard
        } else {
            this.animal = this.animalToCard
        }

        let self = this
        _each(_orderBy(this.animal.states, ['date'], ['desc']), function (s) {
            if (s.state === 'calving') {
                if (self.lactationNumber === 0) {
                    self.lastCalvingDate = s.date
                } else if (self.lactationNumber === 1) {
                    self.beforeLastCalvingDate = s.date
                }
                self.lactationNumber++
            }
        })

    },
    mounted() {
		if (this.this.$parent.$refs.contentRef !== undefined) {
			this.$parent.$refs.contentRef.scrollTop = 0
        }
    },
    methods: {
        ...mapActions(['deleteState']),
        getDetail(s) {
            if (s.state === 'insemination') {
                if (s.hasOwnProperty('insemination') && s.insemination.bull) {
                    return this.$t('card.byBull')
                } else if (s.hasOwnProperty('insemination') && !s.insemination.bull) {
                    return this.$t('card.byArtificialFather')
                } else {
                    return ''
                }

            } else if (s.state === 'ultrasound') {
                if (s.ultrasound.isSuccess) {
                    return this.$t('animal.state.pregnant')
                } else if (s.ultrasound.isVerif) {
                    return this.$t('animal.state.unknown')
                } else {
                    return this.$t('animal.state.empty')
                }
            }
        },
        getLineChartData(results) {
            let chartData = {
                labels: [],
                datasets: [
                    {
                        label: 'Vache : ' + this.animal.buckleNumber,
                        fill: false,
                        borderColor: '#00838F',
                        data: []
                    },
                    {
                        label: this.selectedFarm.name,
                        fill: false,
                        borderColor: '#4DAA71',
                        data: []
                    }
                ]
            }
            let beforeLastCalving = this.animal.beforeLastCalvingDate
            let self = this
            _forEachRight(results, function(r) {
                if (r.date > beforeLastCalving || self.$route.name === 'culled') {
                    chartData.labels.push(format(new Date(r.date * 1000), 'DD/MM/YY'))
                    chartData.datasets[0]['data'].push(r.total)
                    let farmResult = _filter(self.selectedFarm.milkInspections, { 'date': r.date })
                    if (farmResult.length === 1) {
                        chartData.datasets[1]['data'].push(farmResult[0].average)
                    } else {
                        chartData.datasets[1]['data'].push(null)
                    }
                }
            })

            return chartData
        },
        removeState(id) {
            let self = this
            this.deleteState(id).then(animal => {
                let a = { ...animal, fecondity: getFecondityStatus(animal) }
                self.animal = a

            })
        },
        deleteStateDialog(state) {
            this.$dialog
                .confirm(
                    "Supprimer l'état " +
                        this.$t('animal.state.' + state.state) +
                        ' du ' +
                        format(new Date(state.date * 1000), 'DD/MM/YY') +
                        ' ?',
                    {
                        okText: this.$t('button.true'),
                        cancelText: this.$t('button.false')
                    }
                )
                .then(() => {
                    this.removeState(state.id)
                })
                .catch(() => {})
        }
    }
}
</script>

<style lang="sass" scoped>
    @import '../../sass/mixin/color'
    @import '../../sass/mixin/flex'
    @import '../../sass/pwa/animalCard'

    #animal-card
        @include flexbox
        @include flex-direction(column)
        #card-header, #summary, #parents, #productivity, #insemination
            @include flexbox
            @include flex-direction(row)
            @include align-items(center)
        #summary
            @include justify-content(space-between)
        #parents, #insemination, #productivity
            @include justify-content(space-around)


        #card-header
            height: 48px
            background-color: $dd-light-orange
            color: white
            padding: 0 12px
            span
                font-size: 24px
                text-transform: uppercase
            .close-button
                @include flex-center
                cursor: pointer
                &:hover
                    transform: scale(1.2)
        #card-body
            padding: 12px 0
            .card-label
                height: 32px
                border-bottom: solid 2px $dd-light-orange
                span
                    line-height: 36px
                    padding: 0 8px
                    background-color: $dd-light-orange
                    color: white
                    font-size: 20px
            #summary, #parents, #productivity, #insemination
                background-color: $c-g245
                padding: 16px 12px
                margin-bottom: 16px
                font-size: 18px
                strong
                    margin-left: 4px
            #history
                table
                    margin-top: 16px
                    thead
                        background-color: rgba(255,175,68, 0.5)
                        color: $text-color


</style>
